import React from "react";
import "./StorySection.css";

const StorySection = () => {
  return (
    <section className="story-section d-none d-md-block">
      <div className="container text-center">
        <h2 className="story-title">Be A Part Of Our <span className='gaubliisstext'>Gaubliiss</span> A2 Milk Story</h2>
        <div className="custom-divider"></div>
        <div className="row justify-content-center">
          <div className="col-md-3 text-center story-item">
            <div className="story-icon">
              <img src="/milk-icon.png" alt="Milk Icon" />
            </div>
            <p className="story-text">Unmatched Premium <br /> Single Origin Milk</p>
          </div>
          <div className="col-md-3 text-center story-item">
            <div className="story-icon">
              <img src="/farm-icon.png" alt="Farm Icon" />
            </div>
            <p className="story-text">Sourced from picturesque Bhagyaxmi Dairy Farm</p>
          </div>
          <div className="col-md-3 text-center story-item">
            <div className="story-icon">
              <img src="/tech-icon.png" alt="Gear Icon" />
            </div>
            <p className="story-text">Innovative & Advanced Techniques</p>
          </div>
          <div className="col-md-3 text-center story-item">
            <div className="story-icon">
              <img src="/healthy-icon.png" alt="Health Icon" />
            </div>
            <p className="story-text">Healthier Family & A Healthier You</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;